import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlaceFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 2.27661C7.80447 2.27661 4.40359 5.67749 4.40359 9.87301V10.045C4.40359 11.0509 4.71862 12.13 5.17614 13.1796C5.6371 14.2372 6.26407 15.3126 6.9363 16.3238C8.28067 18.3463 9.8441 20.1686 10.7376 21.1602C11.4139 21.9111 12.5861 21.9111 13.2624 21.1602C14.1559 20.1686 15.7193 18.3463 17.0637 16.3238C17.7359 15.3126 18.3629 14.2372 18.8239 13.1796C19.2814 12.13 19.5964 11.0509 19.5964 10.045V9.87301C19.5964 5.67749 16.1955 2.27661 12 2.27661ZM12 7.19461C10.4955 7.19461 9.2766 8.41349 9.2766 9.91801L9.27683 9.93651L9.2766 9.95501C9.2766 11.4595 10.4955 12.6784 12 12.6784C13.5045 12.6784 14.7234 11.4595 14.7234 9.95501V9.91801C14.7234 8.41349 13.5045 7.19461 12 7.19461Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgPlaceFilled);
export default ForwardRef;
